function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 23,
    viewBox: "0 0 149 23",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.816993,0,0,0.872214,-326,-39.8534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.16,58.784C446.16,52.235 455.596,46.924 467.221,46.924C478.847,46.924 488.283,52.235 488.283,58.784C488.283,65.334 478.847,70.642 467.221,70.642C455.596,70.642 446.16,65.334 446.16,58.784ZM451.919,58.639C451.919,53.599 458.772,49.513 467.221,49.513C475.671,49.513 482.542,53.599 482.542,58.639C482.542,63.682 475.671,67.768 467.221,67.768C458.772,67.768 451.919,63.682 451.919,58.639Z",
    style: {
      fill: "rgb(148,17,37)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.727,58.784C491.727,52.235 501.164,46.924 512.789,46.924C524.432,46.924 533.851,52.235 533.851,58.784C533.851,65.334 524.432,70.642 512.789,70.642C501.164,70.642 491.727,65.334 491.727,58.784ZM497.486,58.639C497.486,53.599 504.339,49.513 512.789,49.513C521.257,49.513 528.11,53.599 528.11,58.639C528.11,63.682 521.257,67.768 512.789,67.768C504.339,67.768 497.486,63.682 497.486,58.639Z",
    style: {
      fill: "rgb(148,17,37)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.704,70.354L438.715,53.249L438.715,70.328L443.02,70.328L443.02,47.629L437.782,47.644L422.192,67.497L406.279,47.644L401.023,47.629L401.023,70.328L405.346,70.328L405.346,53.249L419.357,70.354L424.488,70.354",
    style: {
      fill: "rgb(148,17,37)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.813,64.228C575.328,67.751 565.694,71.057 559.2,70.77C547.557,70.77 538.138,65.459 538.138,58.91C538.138,52.36 547.557,47.05 559.2,47.05C568.78,47.05 577.014,50.943 579.562,55.876L573.964,56.968C572.529,53.167 566.699,49.781 559.289,49.781C550.84,49.781 543.915,54.377 543.915,58.982C543.915,63.588 550.696,68.038 559.146,68.038C567.165,68.038 575.005,62.59 575.005,62.59L575.041,61.569L561.963,61.569L561.963,58.695L579.831,58.695C579.831,58.695 579.813,64.046 579.813,64.228Z",
    style: {
      fill: "rgb(148,17,37)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoog);
export default __webpack_public_path__ + "static/media/moog.38a8617659f63914b7b741b10d69ef20.svg";
export { ForwardRef as ReactComponent };